<template>
  <el-dialog title="新增" :visible.sync="newDialogVisible" center @before-close="dialogNewClose" :close-on-click-modal="false">
    <div class="nav">
      <div class="navContainer" style="width: 260px; display: inline-block; margin-bottom: 10px">
        <p style="width: 90px; display: inline-block; text-align: right">对账单编号：</p>
        <el-input v-model="billData.setNo" size="mini" style="width: 160px" placeholder="请输入对账单编号" />
      </div>
      <div class="navContainer" style="width: 270px; display: inline-block; margin-bottom: 10px">
        <p style="width: 60px; display: inline-block; text-align: right">车架号：</p>
        <el-input v-model="billData.frameNumber" size="mini" style="width: 200px" placeholder="请输入车架号" />
      </div>
      <div class="navContainer" style="width: 280px; display: inline-block; margin-bottom: 10px">
        <p style="width: 100px; display: inline-block; text-align: right">对账调整金额：</p>
        <el-input v-model="billData.adjustPrice" size="mini" style="width: 180px" placeholder="请输入对账调整金额" />
      </div>
      <div style="display: inline; margin-left: 10px">
        <el-button size="small" class="searchBtn" @click="onClickSearch">查询</el-button>
      </div>
    </div>
    <div class="tableContent">
      <el-table
        ref="billRef"
        :data="tableDatas"
        @select="handleCurrentChange"
        @select-all="handleCurrentChangeAll"
        :row-key="
          row => {
            return row.id;
          }
        "
        v-loading="tableLoad"
        style="width: 100%"
        border
        :header-cell-style="headerCellStyle"
        highlight-current-row>
        <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
        <el-table-column property="setType" align="center" label="结算类型" width="139">
          <template slot-scope="scope">{{ scope.row.setType == 1 ? '合同价' : '预结算价' }}</template>
        </el-table-column>
        <el-table-column property="title" align="center" label="对账单标题" width="139"></el-table-column>
        <el-table-column property="companyName" align="center" label="公司名称" width="139"></el-table-column>
        <el-table-column property="batchNumber" align="center" label="批次号" width="139"></el-table-column>
        <el-table-column property="waybillNo" align="center" label="运单编号" width="139"></el-table-column>
        <el-table-column property="frameNumber" align="center" label="车架号" width="139"></el-table-column>
        <el-table-column property="taxRate" align="center" label="税率" width="139"></el-table-column>
        <el-table-column property="taxContractPrice" align="center" label="含税合同价" width="139"></el-table-column>
        <el-table-column property="taxPreparePrice" align="center" label="含税预结算价" width="139"></el-table-column>
        <el-table-column property="standingBookMonth" align="center" label="台账月" width="139"></el-table-column>
      </el-table>
    </div>
    <div class="paginationContainer" style="margin-top: 10px">
      <span>共{{ billDataTotal }}条</span>
      <el-pagination :page-sizes="[10, 20, 30, 40]" :page-size="billData.rows" layout=" sizes, prev, pager, next, jumper" :total="billDataTotal" @size-change="billSizeChange" @current-change="billCurrentChange" />
    </div>
    <div class="btnContainer">
      <el-button size="medium" class="searchBtn" :loading="addLoad" @click="onClickAdd">确认</el-button>
      <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import { getAccount, getSettlement, addReconciliationAdjustment } from '@/service/financial';

  export default {
    data() {
      return {
        newDialogVisible: false,
        billData: {
          setNo: '',
          frameNumber: '',
          adjustPrice: '',
          page: 1,
          rows: 10,
        },
        tableDatas: [],
        tableLoad: false,
        billDataTotal: 0,
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '50px',
          background: '#E8E8E8',
        },
        addLoad: false,
        currentRow: [],
        data1: null,
      };
    },
    methods: {
      onClickSearch() {
        // console.log('<<<');
        this.getData();
      },
      async getData() {
        this.tableLoad = true;
        const res1 = await getAccount({ setNo: this.billData.setNo });
        this.data1 = res1.data;
        const res2 = await getSettlement(this.billData);
        if (res2.data['records']) {
          for (let i = 0; i < res2.data.records.length; i++) {
            res2.data.records[i]['setType'] = res1.data['setType'];
            res2.data.records[i]['title'] = res1.data['title'];
            res2.data.records[i]['companyName'] = res1.data['companyName'];
          }
          this.tableDatas = res2.data.records;
          this.billDataTotal = res2.data.total;
          this.tableLoad = false;
        }
      },
      dialogNewClose() {},
      openDialog() {
        this.tableLoad = false;
        this.data1 = null;
        this.billData = {
          setNo: '',
          frameNumber: '',
          adjustPrice: '',
          page: 1,
          rows: 10,
        };
        this.tableDatas = [];
        this.currentRow = [];
        this.newDialogVisible = true;
      },
      billSizeChange(sizes) {
        this.billData.rows = sizes;
        this.getData();
      },
      billCurrentChange(page) {
        this.billData.page = page;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      handleCurrentChangeAll(val) {
        this.currentRow = val;
      },
      async onClickAdd() {
        // console.log(this.currentRow);
        this.data1['id'] = this.currentRow.map(item => item.id).join(',');
        this.data1['taxAdjustPrice'] = this.billData['adjustPrice'];
        // console.log(this.data1);
        const res = await addReconciliationAdjustment(this.data1);
        if (res.status !== 0) return this.$message.warning(res.message);
        this.$message.success(res.message);
        this.newDialogVisible = false;
      },
      dialogClose() {
        this.newDialogVisible = false;
      },
    },
  };
</script>
<style scoped lang="scss">
  .el-pagination {
    white-space: nowrap;
    margin: -22px 43px 10px;
    color: #303133;
    font-weight: 700;
  }
</style>
